import { render, staticRenderFns } from "./SettingsEmailTemplateBuilderEditPage.vue?vue&type=template&id=1a55bab2"
import script from "./SettingsEmailTemplateBuilderEditPage.vue?vue&type=script&lang=ts"
export * from "./SettingsEmailTemplateBuilderEditPage.vue?vue&type=script&lang=ts"
import style0 from "./SettingsEmailTemplateBuilderEditPage.vue?vue&type=style&index=0&id=1a55bab2&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports